import { positionSubscriptionStoreKey } from './positionSubscription.const';
import { IPositionSubscriptionSliceState } from './positionSubscription.types';

interface IState {
  [positionSubscriptionStoreKey]: IPositionSubscriptionSliceState;
}

const selectPositionSubscriptionState = (state: IState) => {
  return state[positionSubscriptionStoreKey];
};

const getSubscriptionDetailsAPIData = (state: IState) => {
  return selectPositionSubscriptionState(state).subscriptionDetails;
};

const getCreateSubscriptionAPIStatus = (state: IState) => {
  return selectPositionSubscriptionState(state).createSubscriptionAPIStatus;
};

const getConfirmSubscriptionAPIStatus = (state: IState) => {
  return selectPositionSubscriptionState(state).confirmSubscriptionAPIStatus;
};

const getUpdateSubscriptionAPIStatus = (state: IState) => {
  return selectPositionSubscriptionState(state).updateSubscriptionAPIStatus;
};

const getUnsubscribeSubscriptionAPIStatus = (state: IState) => {
  return selectPositionSubscriptionState(state)
    .unsubscribeSubscriptionAPIStatus;
};

const getResubscribeSubscriptionAPIStatus = (state: IState) => {
  return selectPositionSubscriptionState(state)
    .resubscribeSubscriptionAPIStatus;
};

export const positionSubscriptionSelectors = {
  getSubscriptionDetailsAPIData,
  getCreateSubscriptionAPIStatus,
  getConfirmSubscriptionAPIStatus,
  getUpdateSubscriptionAPIStatus,
  getUnsubscribeSubscriptionAPIStatus,
  getResubscribeSubscriptionAPIStatus,
};
